"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.WhoIsMainDriverWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var DriverKeeperPopupWidget_1 = require("./DriverKeeperPopupWidget");
var commonFunctions_1 = require("../../commonFunctions");
var FalconQuestionWidgetBase_1 = require("../FalconQuestionWidgetBase");
var WhoIsMainDriverWidget = /** @class */ (function (_super) {
    __extends(WhoIsMainDriverWidget, _super);
    function WhoIsMainDriverWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.vehicleIndex = (0, commonFunctions_1.getIndexSetting)("vehicleIndex", _this.getSetting("vehicleIndex", undefined), _this.props.question.type);
        _this.handleOnChangeEvent = function (event) {
            _this.props.onStateChange(_this.props.question.interactionField, event.target.value);
            _this.setState({
                mainDriverId: event.target.value,
                showConfirmation: false
            });
            _this.changelogRecorder.recordQuestion("change", _this.props);
        };
        var mainDriver = _this.props.interaction.vehicles[_this.vehicleIndex].mainDriverId ?
            _this.props.interaction.vehicles[_this.vehicleIndex].mainDriverId : "";
        _this.state = {
            mainDriverId: mainDriver,
            showConfirmation: false,
            redirect: false
        };
        return _this;
    }
    WhoIsMainDriverWidget.prototype.renderInputField = function () {
        var _this = this;
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", { className: "media-body", children: this.renderHeader() }), (0, jsx_runtime_1.jsx)(DriverKeeperPopupWidget_1.default, { show: this.state.showConfirmation, hide: function () { return _this.setState({ showConfirmation: false }); }, confirm: function () { return _this.props.engine.navigate("anyVehicleAddDriverPage", false); }, title: "Main driver for this car", vehicleRegistrationNumber: "".concat(this.props.interaction.vehicles[this.vehicleIndex].registrationNumber), additionalDriversCount: this.props.interaction.additionalDrivers ? this.props.interaction.additionalDrivers.length : 0, driverFunction: "main driver" }), this.renderDrivers()] }));
    };
    WhoIsMainDriverWidget.prototype.renderHeader = function () {
        var vehicle = this.props.interaction.vehicles[this.vehicleIndex];
        return ((0, jsx_runtime_1.jsxs)("label", { className: "no-outline", children: ["Who is the main driver for ", vehicle.make, ", ", vehicle.model, " (", vehicle.registrationNumber, ")?"] }));
    };
    WhoIsMainDriverWidget.prototype.renderDrivers = function () {
        var vehicle = this.props.interaction.vehicles[this.vehicleIndex];
        var allDrivers = [this.props.interaction.policyHolder].concat(this.props.interaction.additionalDrivers || []);
        var vehicleDrivers = [];
        var vehicleInformation = "".concat(vehicle.make, " ").concat(vehicle.model, " ").concat(vehicle.registrationNumber);
        vehicle.driverIds.forEach(function (driverId) {
            var foundDriver = allDrivers.find(function (driver) { return driver.personId && driverId === driver.personId; });
            if (foundDriver) {
                vehicleDrivers.push((0, jsx_runtime_1.jsxs)("option", { value: driverId, children: [foundDriver.firstName, " ", foundDriver.lastName] }, driverId));
            }
        });
        return ((0, jsx_runtime_1.jsx)("div", { className: "input-group margin-top-14", role: "group", "aria-label": "Who is main driver for this ".concat((0, commonFunctions_1.trimParenthesesFromString)(vehicleInformation), "?"), children: (0, jsx_runtime_1.jsxs)("select", { id: "mainDriver", className: "form-control ".concat(this.getInputValidationClass()), onChange: this.handleOnChangeEvent, onFocus: this.executeNativeEvent, onBlur: this.handleOnBlurEvent, onClick: this.executeNativeEvent, onDoubleClick: this.executeNativeEvent, value: this.bindFromField(this.props.question.interactionField) || "", children: [(0, jsx_runtime_1.jsx)("option", { disabled: true, value: "", children: "Please select..." }), vehicleDrivers] }) }));
    };
    return WhoIsMainDriverWidget;
}(FalconQuestionWidgetBase_1.FalconQuestionWidgetBase));
exports.WhoIsMainDriverWidget = WhoIsMainDriverWidget;
//# sourceMappingURL=WhoIsMainDriverWidget.js.map